<template>
  <main class="judge">
    <myMatches v-show="path == 'myMatches'" />
    <freeMatches v-show="path == 'freeMatches'" />
    <allMatches v-show="path == 'allMatches'" />
    <teams v-show="path == 'teams'" />
    <fieldMap v-show="path == 'map'" />
  </main>
</template>
  
<script>
import { mapState } from "vuex";
import myMatches from "../pages/judge/myMatches";
import freeMatches from "../pages/judge/freeMatches";
import allMatches from "../pages/judge/allMatches";
import teams from "../pages/judge/teams";
import fieldMap from "../pages/judge/map";

export default {
  name: "admin",
  components: {
    myMatches,
    freeMatches,
    allMatches,
    teams,
    fieldMap,
  },
  computed: {
    ...mapState(["path"])
  }
};
</script>